<form [formGroup]="settingsForm" class="form-content" (ngSubmit)="onSubmitSettings()">
  <div class="form-group pt-2">
    <input
      type="checkbox"
      id="performanceInsightsEnabled"
      formControlName="performanceInsightsEnabled" />
    <label class="ps-1" for="performanceInsightsEnabled">
      {{ 'Settings::PerformanceInsights.PerformanceInsightsEnabled' | abpLocalization }}
    </label>
  </div>
  <div *ngIf="performanceInsightsEnabled" class="form-group pt-2 selector-class">
    <label for="performanceInsightsEnabled">
      {{ 'Settings::PerformanceInsights.ReportSections.Description' | abpLocalization }}
    </label>
    <ng-select
      formControlName="reportSections"
      id="reportSections"
      [items]="sectionOptions"
      bindLabel="code"
      bindValue="name"
      [multiple]="true"
      [closeOnSelect]="false">
      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
        <input
          id="item-{{ index }}"
          type="checkbox"
          [disabled]="item.name === 'summary'"
          [ngModel]="item$.selected"
          [ngModelOptions]="{ standalone: true }" />
        {{ 'Settings::PerformanceInsights.ReportSections.' + item.code | abpLocalization }}
      </ng-template>
      <ng-template ng-label-tmp let-item="item">
        <span
          *ngIf="item.name !== 'summary'"
          class="ng-value-icon left"
          aria-hidden="true"
          (click)="removeFromSelectedSections(item.name)">
          ×
        </span>
        <span class="ng-value-label">
          {{ 'Settings::PerformanceInsights.ReportSections.' + item.code | abpLocalization }}
        </span>
      </ng-template>
    </ng-select>
    <div class="form-group pt-2">
      <input 
        type="checkbox"
        id="customPromptEnabled"
        formControlName="customPromptEnabled"/>
      <label class="ps-1" for="customPromptEnabled">
        {{ 'Settings::PerformanceInsights.CustomPromptEnabled' | abpLocalization }}
      </label>
    </div>
    <div *ngIf="customPromptEnabled" class="form-group pt-2">
      <textarea
        id="summaryPrompt"
        formControlName="summaryPrompt"
        class="input-textarea form-control"
        rows="4"></textarea>
      <small class="text-muted">
        "{{ 'Settings::PerformanceInsights.DefaultPrompt' | abpLocalization }}"
        {{ 'Settings::PerformanceInsights.PromptDecription' | abpLocalization }}
      </small>
    </div>
  </div>
  <button type="submit" class="btn btn-primary mt-3">
    <i class="me-1 fas fa-save"></i>
    {{ 'AbpUi::Save' | abpLocalization }}
  </button>
</form>
